module.exports = __webpack_public_path__ + "svgs/error.4d1d9d52.svg";